module.exports = __webpack_public_path__ + "img/Orders.381d90da.svg";